// extracted by mini-css-extract-plugin
export default {"button":"counter_button__0H4A4","input":"counter_input__1uQ-8","container":"counter_container__XByuS","counterContainer":"counter_counterContainer__dqi9B"};